export function EmailSupportResponse() {
  $(document).ready(function () {
    $('#submit-support').click(function (e) {
      e.preventDefault()
      $('#support-form').ajaxSubmit({
        success: function (data) {
          $('#support-form').addClass('d-none')
          $('#form-prompt').addClass('d-none')
          $('#response-message').removeClass('d-none')
          $('#response-message').append(data)
        },
      })
    })
  })
}
